import _regeneratorRuntime from "@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import FirebaseHandler from "../../firebase";
import { removeItem } from "../../cache/cache";
import { httpsCallable } from "firebase/functions";
export var SUBSCRIPTION_INFO_NEXT_DATE_CACHE_ID = "nextDate";
export var setSubscriptionInfo = /*#__PURE__*/ function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/ _regeneratorRuntime.mark(function _callee(email) {
        var setSubscriptionInfo;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        setSubscriptionInfo = httpsCallable(FirebaseHandler.functions, "setSubscriptionInfo");
                        return _context.abrupt("return", setSubscriptionInfo({
                            email: email
                        }));
                    case 2:
                    case "end":
                        return _context.stop();
                }
            }
        }, _callee);
    }));
    return function setSubscriptionInfo(_x) {
        return _ref.apply(this, arguments);
    };
}();
export var removeSubscriptionInfoNextDateFromCache = function removeSubscriptionInfoNextDateFromCache() {
    removeItem("LOCAL_STORAGE", "SUBSCRIPTION_INFO", SUBSCRIPTION_INFO_NEXT_DATE_CACHE_ID);
};
